import {Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Router} from "@angular/router";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";
import {hanjaWordMixin} from "../../mixins/hanja-word.mixin";

@Component({
  selector: 'app-hanja-content',
  templateUrl: './hanja-content.component.html',
  styleUrls: ['./hanja-content.component.scss']
})
export class HanjaContentComponent extends hanjaWordMixin implements OnInit, OnDestroy {
  @Input() hanjas?: string;
  @Input() selected: string | null = null;  // 선택된 한자. TODO: CSS 추가 필요.
  @Input() hangul?: string;    // 음 (1글자, 예: "국")
  @Input() firstHun?: string;  // 대표 훈 (예: "나라")

  get chars(): string[] {
    return this.hanjas ? Array.from(this.hanjas) : [];
  }

  private unlisten: (() => void) | null = null;

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm);
  }

  ngOnInit(): void {
    this.unlisten = this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      const clickedElement = event.target as HTMLElement;
      // console.warn('HanjaContentComponent.onClick() : event=', event, clickedElement);

      if (clickedElement.classList.contains('hanja-txt')) {

        event.preventDefault();
        event.stopPropagation();
        this.globalEventSvc.Click(event, true);

        const hanja = clickedElement.textContent?.trim();
        console.warn('클릭된 한자:', hanja);

        if (hanja) {
          this.OpenHanjaWord(hanja, this.hangul, this.firstHun).subscribe(result => {
            console.log('HanjaCharComponent.onClick() : result=', result);
          });
        }
        else {
          console.error('HanjaCharComponent.onClick() : hanja is null');
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }
}
